var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudDownloadOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 26.659C9.23096 26.659 5.5 22.9281 5.5 18.3257C5.5 14.2449 8.4332 10.8492 12.3063 10.132C13.0235 6.25888 16.4192 3.32568 20.5 3.32568C24.5808 3.32568 27.9765 6.25888 28.6937 10.132C32.5668 10.8492 35.5 14.2449 35.5 18.3257C35.5 22.9281 31.769 26.659 27.1667 26.659M15.5 31.659L20.5 36.659M20.5 36.659L25.5 31.659M20.5 36.659V16.659",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudDownloadOff);
export default __webpack_public_path__ + "static/media/CloudDownloadOff.2429fb844af57c9f2d81818b48324808.svg";
export { ForwardRef as ReactComponent };